module.exports = __webpack_public_path__ + "img/meals-types.0781a98f.svg";